import { useQuery } from '@tanstack/react-query';
import { getShipmentKpis } from '../../api';
import { queryKeys } from './queryKeys';

export function useShipmentKpis(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.shipments.kpis(),
    queryFn: () => getShipmentKpis(),
    enabled: options?.enabled ?? true,
  });
}
